import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { newButtonText: String }

  copyUrl() {
    navigator.clipboard.writeText(window.location.href)

    if (this.hasNewButtonTextValue) {
      const originalText = this.element.textContent
      this.updateTextNode(this.newButtonTextValue)

      setTimeout(() => {
        this.updateTextNode(originalText)
      }, 1500)
    }
  }

  updateTextNode(text) {
    this.element.childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== "") {
        node.textContent = text;
      }
    });
  }
}
